<template>
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_131_7435)">
      <path
        d="M16.6668 1.66667H3.3335V18.3333H16.6668V1.66667ZM5.00016 3.33334H9.16683V10L7.0835 8.75L5.00016 10V3.33334Z"
        fill="currentColor"
      />
    </g>
  </svg>
</template>
<script lang="ts" setup></script>
